import { Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <Header />
        
        <main className="pt-24 pb-16">
          <div className="max-w-4xl mx-auto px-6">
            <h1 className="text-4xl md:text-5xl font-display font-bold text-navy-900 mb-8">
              Terms of Service
            </h1>

            <div className="prose prose-lg max-w-none">
              <p className="text-navy-600 mb-6">
                <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">1. Acceptance of Terms</h2>
                <p className="text-navy-600">
                  By accessing and using the services of Florida AI Marketing Experts, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use our services.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">2. Services Description</h2>
                <p className="text-navy-600 mb-4">
                  Florida AI Marketing Experts provides AI-powered marketing services including but not limited to:
                </p>
                <ul className="list-disc pl-6 text-navy-600 space-y-2">
                  <li>ChatGPT Ads readiness and optimization</li>
                  <li>GEO/AI search optimization</li>
                  <li>Voice AI implementation</li>
                  <li>AI marketing strategy consulting</li>
                  <li>Digital marketing services</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">3. User Obligations</h2>
                <p className="text-navy-600 mb-4">
                  You agree to:
                </p>
                <ul className="list-disc pl-6 text-navy-600 space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Maintain the confidentiality of your account credentials</li>
                  <li>Use our services in compliance with all applicable laws</li>
                  <li>Not engage in any activity that interferes with our services</li>
                  <li>Not use our services for any unlawful purpose</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">4. Payment Terms</h2>
                <p className="text-navy-600 mb-4">
                  Payment terms are as follows:
                </p>
                <ul className="list-disc pl-6 text-navy-600 space-y-2">
                  <li>All fees are due as specified in your service agreement</li>
                  <li>Payments are non-refundable unless otherwise stated</li>
                  <li>We reserve the right to modify pricing with 30 days notice</li>
                  <li>Late payments may result in service suspension</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">5. Intellectual Property</h2>
                <p className="text-navy-600">
                  All content, trademarks, and intellectual property on our website and in our services remain the property of Florida AI Marketing Experts. You may not use, reproduce, or distribute our content without written permission.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">6. Service Modifications</h2>
                <p className="text-navy-600">
                  We reserve the right to modify, suspend, or discontinue any aspect of our services at any time. We will provide reasonable notice of significant changes.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">7. Limitation of Liability</h2>
                <p className="text-navy-600 mb-4">
                  To the maximum extent permitted by law:
                </p>
                <ul className="list-disc pl-6 text-navy-600 space-y-2">
                  <li>We are not liable for indirect, incidental, or consequential damages</li>
                  <li>Our total liability shall not exceed the amount paid for services</li>
                  <li>We do not guarantee specific results from our services</li>
                  <li>We are not responsible for third-party services or platforms</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">8. Warranties and Disclaimers</h2>
                <p className="text-navy-600">
                  Our services are provided "as is" without warranties of any kind. We do not guarantee uninterrupted or error-free service. Results may vary based on numerous factors beyond our control.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">9. Termination</h2>
                <p className="text-navy-600">
                  Either party may terminate services with written notice as specified in the service agreement. We reserve the right to terminate services immediately for violation of these terms.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">10. Confidentiality</h2>
                <p className="text-navy-600">
                  Both parties agree to maintain confidentiality of proprietary information shared during the course of our business relationship.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">11. Dispute Resolution</h2>
                <p className="text-navy-600">
                  Any disputes arising from these terms shall be resolved through binding arbitration in accordance with Florida law. The venue shall be in Miami-Dade County, Florida.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">12. Governing Law</h2>
                <p className="text-navy-600">
                  These terms are governed by the laws of the State of Florida, without regard to conflict of law provisions.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">13. Changes to Terms</h2>
                <p className="text-navy-600">
                  We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the modified terms.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-display font-bold text-navy-900 mb-4">14. Contact Information</h2>
                <p className="text-navy-600 mb-4">
                  For questions about these Terms of Service, please contact us:
                </p>
                <div className="bg-navy-50 p-6 rounded-lg">
                  <p className="text-navy-600">
                    <strong>Florida AI Marketing Experts</strong><br />
                    Email: legal@floridaaimarketingexperts.com<br />
                    Phone: (305) 555-0123<br />
                    Address: Miami, Florida
                  </p>
                </div>
              </section>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </Suspense>
  );
}
